import { createAction, createSlice } from "@reduxjs/toolkit";

const createCourseSlice = createSlice({
  name: "createCourse",
  initialState: { data: null, processing: false, isSuccess: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      state.data = action.payload.data;
      state.isSuccess = action.payload.isSuccess;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    reset(state) {
      state.isSuccess = false;
    },
  },
});

const { name, actions, reducer } = createCourseSlice;
const createCourseAction = createAction(name);

export {
  createCourseAction,
  actions as createCourseActions,
  reducer as createCourseReducer,
};
